import { secureGet } from '../../utils/HttpUtils';

const VIRTUAL_ACCOUNT_BASE_URL = window.virtualAccountUrl?.url;

const VIRTUAL_ACCOUNT_ENDPOINT = {
  STATUS: `${VIRTUAL_ACCOUNT_BASE_URL}/v1/web/private/accounts/status`,
};

export const fetchQualification = () => {
  return secureGet(VIRTUAL_ACCOUNT_ENDPOINT.STATUS, {});
};
